import CategoryView from "src/organisms/CategoryView";

export default function ProductCategorieIndex(): JSX.Element {
  return <CategoryView />;
}
